import React, { useRef } from 'react';
import { Form } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import { customStyles } from '~/Styles/reactSelectStyles';
import { autocompleteEntidadeDigitalizacao } from '~/Services/Service';

const EntidadeAutocomplete = ({
  tipo,
  label,
  placeholder,
  entidadeSelecionada,
  onChangeEntidade,
  codigoGrupoEmpresa,
  exigeGrupoEmpresa = false,
}) => {
  const debounceTimerRef = useRef(null);

  const loadOptions = (termo, callback) => {
    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    if (!termo || termo.length < 2) {
      callback([]);
      return;
    }
    if (exigeGrupoEmpresa && !codigoGrupoEmpresa) {
      callback([]);
      return;
    }
    debounceTimerRef.current = setTimeout(async () => {
      try {
        const lista = await autocompleteEntidadeDigitalizacao(tipo, termo, codigoGrupoEmpresa);
        const opcoes = (lista || []).map((item) => ({
          value: item.codigo,
          label: `${item.codigo} - ${item.nome || ''}`,
          item,
        }));
        callback(opcoes);
      } catch (_err) {
        callback([]);
      }
    }, 300);
  };

  const valorSelecionado = entidadeSelecionada
    ? {
        value: entidadeSelecionada.codigo,
        label: `${entidadeSelecionada.codigo} - ${entidadeSelecionada.nome || ''}`,
        item: entidadeSelecionada,
      }
    : null;

  const disabled = exigeGrupoEmpresa && !codigoGrupoEmpresa;

  return (
    <Form.Group>
      <Form.Label className="small mb-1">{label}</Form.Label>
      <AsyncSelect
        loadOptions={loadOptions}
        value={valorSelecionado}
        onChange={(opt) => onChangeEntidade(opt ? opt.item : null)}
        placeholder={placeholder}
        isClearable
        isDisabled={disabled}
        noOptionsMessage={({ inputValue }) =>
          disabled
            ? 'Selecione um Grupo de Empresa primeiro'
            : inputValue && inputValue.length >= 2
              ? 'Nenhum resultado encontrado'
              : 'Digite ao menos 2 caracteres'
        }
        loadingMessage={() => 'Buscando...'}
        styles={{
          ...customStyles,
          menuPortal: (base) => ({ ...base, zIndex: 1060 }),
        }}
        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      />
    </Form.Group>
  );
};

export default EntidadeAutocomplete;
